import get from 'lodash/get';
import {
    BUNDLE_NETPRICE_SUCCESS,
    BUNDLE_NETPRICE_POST_ERROR,
} from '../actionTypes/BundleNetPriceActionTypes';

function BundleNetPriceReducer(state = [], action) {
    switch (action.type) {
        case BUNDLE_NETPRICE_SUCCESS: {
            const bundleNetPriceDetails = get(action, 'payload.bundleNetPriceDetails', state);
            return bundleNetPriceDetails;
        }
        case BUNDLE_NETPRICE_POST_ERROR: {
            const resetBundlePrice = action.payload && {};
            return resetBundlePrice;
        }
        default:
            return state;
    }
}

BundleNetPriceReducer.reducerName = 'bundleNetPriceDetails';
export default BundleNetPriceReducer;
